import { Component, OnInit } from '@angular/core';
import {Router} from "@angular/router";
import {Title} from "@angular/platform-browser";
import {ReviewService} from "../../review.service";

@Component({
  selector: 'app-each-otzyv',
  templateUrl: './each-otzyv.component.html',
  styleUrls: ['./each-otzyv.component.scss']
})
export class EachOtzyvComponent implements OnInit {
  reviews;
  currItem;
  constructor(private router: Router, private reviewService: ReviewService, private titleService: Title) { }

  ngOnInit(): void {
    const currId =  this.router.url.split('/')[this.router.url.split('/').length-1];
    this.reviewService.getAll().subscribe((res:any) => {
      this.reviews = res.results;
      console.log(res);
      this.currItem = this.reviews.find(el => el.id === Number(currId));
      this.titleService.setTitle(this.currItem.title);
    });
  }

}
